import React from 'react';
import styled from 'styled-components';
import { FiSearch, FiFolderPlus, FiUpload, FiDownload } from 'react-icons/fi';
import PillButton from './PillButton';
import { assetTheme as t } from './assetTheme';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`

const Search = styled.div`
  flex: 1;
  min-width: 200px;
  display: flex;
  align-items: center;
  gap: 10px;
  background: ${t.surface};
  border: 1px solid ${t.border};
  border-radius: 999px;
  padding: 10px 16px;
  color: ${t.faint};

  input {
    flex: 1;
    border: none;
    outline: none;
    background: transparent;
    font-family: ${t.fontFamily};
    font-size: 14px;
    color: ${t.text};

    &::placeholder {
      color: ${t.faint};
    }
  }
`

const TruncationNote = styled.div`
  font-size: 13px;
  font-style: italic;
  color: #fa8900;
`

export default ({
  searchTerm,
  onSearchChange,
  isTruncated,
  canDownloadAll,
  onDownloadAll,
  onNewFolder,
  onUploadFiles
}) => {
  return (
    <Wrapper>
      <Row>
        <Search>
          <FiSearch />
          <input
            type='text'
            placeholder='Search assets'
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
          />
        </Search>
        {
          canDownloadAll &&
          <PillButton onClick={onDownloadAll}>
            <FiDownload />
            {'Download all'}
          </PillButton>
        }
        <PillButton onClick={onNewFolder}>
          <FiFolderPlus />
          {'New folder'}
        </PillButton>
        <PillButton $primary={true} onClick={onUploadFiles}>
          <FiUpload />
          {'Upload files'}
        </PillButton>
      </Row>
      {isTruncated && <TruncationNote>{'Showing the first 1,000 items in this folder'}</TruncationNote>}
    </Wrapper>
  )
}
